import { render, staticRenderFns } from "./detailsStatus.vue?vue&type=template&id=d2884128&scoped=true"
import script from "./detailsStatus.vue?vue&type=script&lang=js"
export * from "./detailsStatus.vue?vue&type=script&lang=js"
import style0 from "./detailsStatus.vue?vue&type=style&index=0&id=d2884128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2884128",
  null
  
)

export default component.exports